import { AccredibleGeolocation } from '@accredible-frontend-v2/models';
import { AccredibleApiService } from '@accredible-frontend-v2/services/api';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const GEOLOCATE_API_URL = '/v1/common/locations/geolocate';

@Injectable({ providedIn: 'root' })
export class AccredibleGeolocationApiService extends AccredibleApiService {
  geolocate(): Observable<AccredibleGeolocation> {
    return this._get(GEOLOCATE_API_URL).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res)),
    );
  }
}
